export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20flat%20lay%20of%20diverse%20contemporary%20fashion%20items%20including%20sneakers%20hoodies%20crossbody%20bags%20caps%20and%20accessories%20arranged%20elegantly%20on%20a%20warm%20cream%20linen%20surface%20with%20scattered%20natural%20greenery%20accents%20soft%20diffused%20natural%20daylight%20from%20a%20large%20window%20creating%20gentle%20shadows%20refined%20modern%20aesthetic%20high%20end%20catalog%20style%20with%20generous%20negative%20space%20airy%20sophisticated%20atmosphere&width=1600&height=900&seq=hero-main-fresh-july26-v3&orientation=landscape"
          alt="Superbuy Spreadsheet - Curated fashion shopping companion"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-full px-4 py-1.5 mb-6">
          <i className="ri-sparkling-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
          <span className="text-xs md:text-sm text-foreground-700 font-medium">Updated July 2026 • Community Trusted</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          Superbuy Spreadsheet
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          Your ultimate curated shopping companion. Discover verified product links, QC references,
          and expert buying guides — all in one organized spreadsheet.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-8 py-3 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer text-sm md:text-base"
          >
            <i className="ri-shopping-bag-line w-5 h-5 flex items-center justify-center"></i>
            Superbuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-white/90 backdrop-blur-sm hover:bg-white text-foreground-900 font-semibold px-8 py-3 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer text-sm md:text-base"
          >
            <i className="ri-flashlight-line w-5 h-5 flex items-center justify-center"></i>
            Buy It Now
          </a>
        </div>

        <div className="flex items-center justify-center gap-3 text-white/70">
          <div className="flex items-center gap-1.5">
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-accent-400"></i>
            <span className="text-xs">Verified Links</span>
          </div>
          <span className="text-white/30">•</span>
          <div className="flex items-center gap-1.5">
            <i className="ri-team-line w-4 h-4 flex items-center justify-center text-accent-400"></i>
            <span className="text-xs">Community Vetted</span>
          </div>
          <span className="text-white/30">•</span>
          <div className="flex items-center gap-1.5">
            <i className="ri-refresh-line w-4 h-4 flex items-center justify-center text-accent-400"></i>
            <span className="text-xs">Regularly Updated</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <a
          href="#categories"
          className="flex flex-col items-center gap-2 text-white/60 hover:text-white/90 transition-colors cursor-pointer"
        >
          <span className="text-xs font-medium">Browse Categories</span>
          <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}